<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-title>
        Команда точкам
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="3"
          >
            <skud-place-select />
          </v-col>
        </v-row>
        <v-alert
          v-if="!place"
          type="info"
          outlined
          class="mt-4 mb-0"
        >
          Выберите место
        </v-alert>
        <template v-else>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="type"
                :items="typeOptions"
                label="Тип команды"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <skud-point-select
                v-model="pointId"
                :place-id="place"
                :multiple="false"
                label="Точка (point_id)"
                hint="пусто = всем точкам места"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="doorAction"
                :items="doorOptions"
                label="Открыть/Закрыть дверь"
                outlined
                dense
                :disabled="!doorMenuEnabled"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="festive"
            dense
          >
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="festiveTheme"
                :items="festiveThemes"
                label="Тема"
                outlined
                dense
                :rules="festiveThemeRules"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <skud-date-field
                v-model="festiveExpires"
                with-time
                label="Вернуть тему по умолчанию"
                :max="festiveMaxDate"
                :rules="festiveExpiresRules"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              sm="8"
            >
              <v-textarea
                v-model="payload"
                label="Payload (JSON)"
                :placeholder="'{\&quot;theme\&quot;:\&quot;ny\&quot;}'"
                hint="JSON для festive"
                persistent-hint
                outlined
                dense
                rows="3"
                :rules="payloadRules"
              />
            </v-col>
          </v-row>
          <v-btn
            color="primary"
            outlined
            :loading="loading"
            @click="confirm()"
          >
            <span class="mx-3">
              Отправить </span>
          </v-btn>
        </template>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog_confirm"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Подтверждение</span>
        </v-card-title>
        <v-card-text>
          <span :class="danger ? 'red--text' : ''">
            Отправить команду «{{ svc ? svc.typeText(type) : type }}» {{ pointId ? 'точке ' + pointId : 'всем точкам места' }}?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="send()"
          >
            <span class="mx-4">Отправить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_confirm = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SkudPlaceSelect from '@/views/skud/components/SkudPlaceSelect.vue'
import SkudPointSelect from '@/views/skud/components/SkudPointSelect.vue'
import SkudDateField from '@/views/skud/components/SkudDateField.vue'
import { SkudCommandService } from '@/views/skud/shared/services/skud-command-service'
import { PointCommandType, enumOptions } from '@/views/skud/shared/models/enums'
import moment from 'moment'

// Типы, требующие повышенного внимания при подтверждении.
const DANGER_TYPES = [0, 1, 8]

// Темы праздничного режима (type 5), value — как в payload.
const FESTIVE_THEMES = [
  { value: 'sept', text: 'День знаний' },
  { value: 'ny', text: 'Новый год' },
  { value: 'bell', text: 'Последний звонок' },
  { value: 'mar8', text: 'Международный женский день' },
  { value: 'feb23', text: 'День защитника отечества' },
  { value: 'teacher', text: 'День учителя' },
  { value: 'cosmo', text: 'День космонавтики' }
]

export default {
  name: 'SkudCommandForm',
  components: {
    SkudPlaceSelect,
    SkudPointSelect,
    SkudDateField
  },
  data () {
    return {
      svc: null,
      type: null,
      pointId: null,
      doorAction: null,
      festiveTheme: null,
      festiveExpires: '',
      doorOptions: [
        { text: 'Нет действий', value: null },
        { text: 'Открыть дверь', value: 'open' },
        { text: 'Закрыть дверь', value: 'close' }
      ],
      payload: '',
      loading: false,
      dialog_confirm: false,
      typeOptions: enumOptions(PointCommandType),
      festiveThemes: FESTIVE_THEMES,
      festiveThemeRules: [v => !!v || 'Выберите тему'],
      festiveExpiresRules: [v => !!v || 'Укажите дату и время'],
      payloadRules: [
        v => {
          if (!v) return true
          try {
            JSON.parse(v)
            return true
          } catch (e) {
            return 'Невалидный JSON'
          }
        }
      ]
    }
  },
  computed: {
    place () {
      return this.$store.state.skud_place
    },
    danger () {
      return DANGER_TYPES.indexOf(this.type) > -1
    },
    doorMenuEnabled () {
      return this.type !== null && this.type <= 4
    },
    festive () {
      return this.type === 5
    },
    festiveMaxDate () {
      return moment().add(3, 'days').format('YYYY-MM-DD')
    }
  },
  watch: {
    doorAction (v) {
      this.payload = v === 'open' ? '{"door":"open"}' : v === 'close' ? '{"door":"close"}' : ''
    },
    doorMenuEnabled (on) {
      if (!on) {
        this.payload = ''
        this.doorAction = null
      }
    },
    festiveTheme () {
      this.updateFestivePayload()
    },
    festiveExpires () {
      this.updateFestivePayload()
    },
    festive (on) {
      if (!on) {
        this.festiveTheme = null
        this.festiveExpires = ''
        this.payload = ''
      }
    }
  },
  mounted () {
    this.svc = new SkudCommandService()
  },
  methods: {
    updateFestivePayload () {
      if (this.type !== 5) return
      const body = {}
      if (this.festiveTheme) body.theme = this.festiveTheme
      if (this.festiveExpires) body.expires_at = moment(this.festiveExpires).toISOString()
      this.payload = JSON.stringify(body)
    },
    confirm () {
      if (this.type === null || this.type === undefined) {
        this.$store.commit('snackbar', 'Выберите тип команды')
        return
      }
      if (this.festive) {
        if (!this.festiveTheme) {
          this.$store.commit('snackbar', 'Выберите тему')
          return
        }
        if (!this.festiveExpires) {
          this.$store.commit('snackbar', 'Укажите дату и время возврата темы')
          return
        }
        if (moment(this.festiveExpires).isAfter(moment().add(3, 'days'))) {
          this.$store.commit('snackbar', 'Дата возврата — не позднее 3 дней от текущей')
          return
        }
      }
      if (this.payload) {
        try {
          JSON.parse(this.payload)
        } catch (e) {
          this.$store.commit('snackbar', 'Невалидный JSON в payload')
          return
        }
      }
      this.dialog_confirm = true
    },
    async send () {
      this.dialog_confirm = false
      this.loading = true
      const res = await this.svc.issueCommand(this.place, {
        type: this.type,
        point_id: this.pointId || null,
        payload: this.payload || null
      })
      this.loading = false
      if (!res.ok) {
        this.$store.commit('snackbar', res.error)
        return
      }
      this.$store.commit('snackbar', 'Команда отправлена: ' + res.data.command_id)
    }
  }
}
</script>
